import { Card, EmptyState } from "@heroui/react";

import type { NavItem } from "@/src/components/layout/navigation";
import { useTranslations } from "@/src/i18n/i18n";

/**
 * Écran non encore construit.
 *
 * Il existe pour une raison précise : **aucun lien de la navigation ne doit
 * tomber dans le vide**. Une entrée désactivée serait pire — elle laisse
 * croire à une panne — et une route absente enverrait sur la 404, qui dit le
 * contraire de la vérité (l'écran est prévu, il n'est pas écrit).
 *
 * ⚠️ Ce n'est **pas** le modèle d'un écran réel. Le jour où l'un d'eux est
 * construit, il prend son propre dossier dans `src/pages/`, avec ses
 * `components/` et ses `hooks/` — et il disparaît d'ici.
 */
export function Placeholder({ section }: { section: NavItem["key"] }) {
  const t = useTranslations("placeholder");
  const tn = useTranslations("navigation");

  return (
    <Card className="mx-auto w-full max-w-6xl p-10">
      <Card.Content>
        <EmptyState className="flex flex-col items-center gap-2 text-center">
          <p className="text-base font-medium">
            {tn(section)} — {t("title")}
          </p>
          <p className="max-w-md text-pretty text-muted">{t("description")}</p>
        </EmptyState>
      </Card.Content>
    </Card>
  );
}
